/**
 * Meander: a band of Greek key, the border that runs round the rim of almost
 * every painted Athenian pot. Purely decorative, so it is hidden from
 * assistive technology.
 *
 * It takes its colour from the text colour of its parent (currentColor), so
 * set that with a Tailwind text class: `text-courtyard-gold/60`.
 */
import React, { useId } from 'react';
import { clsx } from 'clsx';

// One repeat of the key is 16 wide and 12 tall: a rail above, a rail below,
// and a squared hook turning in on itself between them.
const UNIT_W = 16;
const UNIT_H = 12;

const Meander = ({ height = 12, className }) => {
  // useId gives ':r1:'; the colons are legal in an id but awkward inside url().
  const id = `meander-${useId().replace(/:/g, '')}`;
  const scale = height / UNIT_H;

  return (
    <svg
      width="100%"
      height={height}
      className={clsx('block', className)}
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <pattern
          id={id}
          width={UNIT_W}
          height={UNIT_H}
          patternUnits="userSpaceOnUse"
          patternTransform={`scale(${scale})`}
        >
          <path
            d="M0 0.75 H16 M0 11.25 H16 M1.5 11.25 V3.5 H12.5 V8.75 H5.5 V6.25 H9.5"
            fill="none"
            stroke="currentColor"
            strokeWidth={1.5}
            strokeLinecap="square"
          />
        </pattern>
      </defs>
      <rect width="100%" height={height} fill={`url(#${id})`} />
    </svg>
  );
};

export default Meander;
